import { Box, Typography } from "@mui/material";

const CustomGridCell = (props) => {
  let className = "apeWhiteColor";
  if(props.color == "black"){
    className = "apeBlackColor";
  }
  else if(props.color == null){
    className = "apeBlueColor";
  }
  return (
    <Box
      spacing={0.5}
      display={props.display}
      alignItems={props.alignItems}
      sx={{
        backgroundColor: props.backgroundColor,
        width: props.width,
        height: props.heigth,
        textAlign: props.textAlign,
      }}
    >
      {props.item1 !== undefined ? (
        <Typography
          variant="subtitle2"
          sx={{
            height: 20,
            width: "100%",
            textAlign: props.color != null && props.color != "black" ? "center" : "",
            display: props.item1Display
          }}
          className={className}
        >
          {props.item1}
        </Typography>
      ) : (
        <Typography sx={{ height: 20 }}> </Typography>
      )}

      {props.item2 !== undefined ? (
        <Typography
          variant="subtitle2"
          sx={{ height: 20, display: props.rowsToDisplay == 1 ? "none" : "" }}
          className="apePinkColor"
        >
          {props.item2}
        </Typography>
      ) : (
        <Typography sx={{ height: 20 }}> </Typography>
      )}

      {props.item3 !== undefined ? (
        <Typography
          variant="subtitle2"
          sx={{ height: 20, display: props.rowsToDisplay == 1 || props.rowsToDisplay == 2 ? "none" : ""  }}
          className={props.isHighlight ? "highlight" : ""}
        >
          {props.item3}
        </Typography>
      ) : (
        <Typography sx={{ height: 20 }}> </Typography>
      )}
    </Box>
  );
};

export default CustomGridCell;
